"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var DynoActions = _interopRequireWildcard(require("lead-flows-ui/actions/Dynos"));

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

var _Container = _interopRequireDefault(require("lead-flows-ui/components/common/Container"));

var _AppLink = _interopRequireDefault(require("lead-flows-ui/components/common/AppLink"));

var _ErrorMessage = _interopRequireDefault(require("lead-flows-ui/components/common/ErrorMessage"));

var LeadFlowByGuidGetter = _react.default.createClass({
  displayName: "LeadFlowByGuidGetter",
  propTypes: {
    formGuid: _react.default.PropTypes.string.isRequired,
    navigateToDynoByGuid: _react.default.PropTypes.func.isRequired,
    failedToGetDynoByGuid: _react.default.PropTypes.bool.isRequired
  },
  componentWillMount: function componentWillMount() {
    var _this$props = this.props,
        formGuid = _this$props.formGuid,
        navigateToDynoByGuid = _this$props.navigateToDynoByGuid;
    navigateToDynoByGuid(formGuid);
  },
  getLangKey: function getLangKey(suffix) {
    return "leadFlowMissingMessage." + suffix;
  },
  hasFailed: function hasFailed() {
    return this.props.failedToGetDynoByGuid;
  },
  renderFormMissingMessage: function renderFormMissingMessage() {
    var dashboardLink = _react.default.createElement(_AppLink.default, {
      href: (0, _RouteGenerators.getDashboardRoute)()
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.getLangKey('goToDashCta')
    }));

    return _react.default.createElement(_ErrorMessage.default, {
      heading: _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('heading')
      }),
      message: _react.default.createElement(_FormattedReactMessage.default, {
        message: this.getLangKey('description'),
        options: {
          dashboardLink: dashboardLink
        }
      })
    });
  },
  render: function render() {
    var contents = this.hasFailed() ? this.renderFormMissingMessage() : _react.default.createElement(_UILoadingSpinner.default, {
      grow: true
    });
    return _react.default.createElement(_Container.default, null, contents);
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    failedToGetDynoByGuid: state.dynos.failedToGetDynoByGuid
  };
};

var actionsToBind = {
  navigateToDynoByGuid: DynoActions.navigateToDynoByGuid
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionsToBind)(LeadFlowByGuidGetter);

exports.default = _default;
module.exports = exports.default;